<template>
    <div class="tictactoe">
      <h1>井字棋游戏喵！</h1>
      <div class="board">
        <div v-for="(cell, index) in board" :key="index" class="cell" @click="makeMove(index)">
          {{ cell }}
        </div>
      </div>
      <p>{{ status }}</p>
      <button @click="resetGame">重新开始喵</button>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        board: Array(9).fill(''),
        currentPlayer: 'X',
        status: '轮到 X 喵～',
      };
    },
    methods: {
      makeMove(index) {
        if (this.board[index] || this.checkWin()) return;
        this.board.splice(index, 1, this.currentPlayer);
        if (this.checkWin()) {
          this.status = `${this.currentPlayer} 赢了喵！`;
          return;
        }
        if (this.board.every(cell => cell)) {
          this.status = '平局喵！';
          return;
        }
        this.currentPlayer = this.currentPlayer === 'X' ? 'O' : 'X';
        this.status = `轮到 ${this.currentPlayer} 喵～`;
      },
      checkWin() {
        const winPatterns = [
          [0, 1, 2], [3, 4, 5], [6, 7, 8], // 行
          [0, 3, 6], [1, 4, 7], [2, 5, 8], // 列
          [0, 4, 8], [2, 4, 6], // 对角线
        ];
        return winPatterns.some(pattern =>
          pattern.every(index => this.board[index] === this.currentPlayer)
        );
      },
      resetGame() {
        this.board = Array(9).fill('');
        this.currentPlayer = 'X';
        this.status = '轮到 X 喵～';
      },
    },
  };
  </script>
  
  <style>
  .tictactoe {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .board {
    display: grid;
    grid-template-columns: repeat(3, 100px);
    gap: 5px;
  }
  .cell {
    width: 100px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    background-color: #e0e0e0;
    cursor: pointer;
  }
  button {
    margin-top: 20px;
    padding: 5px 10px;
    background-color: #f44336;
    color: white;
    border: none;
    cursor: pointer;
  }
  </style>
  